<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { ProjectProposalLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectProposalLifecycleSetter"

    // props
    const props = defineProps<{
        viewModel: ProjectProposalLifecycleSetterViewModel
    }>()

    // emits
    const emit = defineEmits<{
        (e: 'confirm', projectId: string): void
    }>()

    // vm shortcut
    const vm = toRef(props, 'viewModel')

    // state
    const opened = computed(() => vm.value?.opened ?? false)

    // actions
    function confirm()
    {
        emit('confirm', vm.value.projectId)
    }

    function close()
    {
        vm.value.close()
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Revert Project Lifecycle to Proposal</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p>
                            You are about to set the project lifecycle back to the <strong>Proposal</strong> stage.
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="button" @click="confirm" class="btn btn-primary">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
